import React, { useState, useEffect } from 'react';
import DatePicker from '../../DatePicker/DatePicker.component';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { Button, makeStyles, TextField, Typography, Grid, Select, MenuItem, InputLabel, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, CircularProgress } from '@material-ui/core';
import Dialog from '../../ui/Dialog';
import moment from 'moment';
import { createEducationalReference, getEducationalReferenceById, getEducationalReferenceList } from '../../../services/educationalReference.service';
import { upload } from '../../../services/storage.service';
const AddEducationalReference = ({ data }) => {
    const [openModal, setOpenModal] = useState(false);

    const [openConfirmation, setConfirmation] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorInputMessage, setErrorInputMessage] = useState(null);
    const [fileToUpload, setFileToUpload] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadError, setUploadError] = useState(null);
    const [sourceType, setSourceType] = useState('upload'); // 'upload' or 'url'
    const [educationalReferenceDetails, setEducationalReferenceDetails] = useState({
        language: '',
        attachment_type: '',
        citation: '',
        url: '',
        title: '',
        description: ''
    })

    const { match } = data;
    const programId = match.params.connect_program_id;
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    const patient_id = searchParams.get('patient_id');

    const useStyles = makeStyles((theme) => ({
        field: {
            marginBottom: 10,
            width: '100%',
            minWidth: '500px'
        },
        select: {
            width: '100%'
        },
        formControl: {
            width: '100%'
        },
        customWidth: {
            '& .MuiDialog-paper': {
                width: '800px',
                maxWidth: '800px',
            }
        },
        errorText: {
            color: 'red',
            fontSize: '0.75rem',
            marginTop: 3,
        },
        tableContainer: {
            marginTop: theme.spacing(2),
            maxHeight: 400,
        },
        tableHeader: {
            backgroundColor: theme.palette.grey[100],
            fontWeight: 'bold',
        },
        actionCell: {
            display: 'flex',
            gap: theme.spacing(3),
        },
        noteCell: {
            maxWidth: 300,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        dialogTitle: {
            borderBottom: '1px solid #E0E0E0',
            paddingBottom: theme.spacing(2),
        },
        mainDialogContent: {
            padding: theme.spacing(3),
            minWidth: 800,
        },
        secondaryDialogContent: {
            padding: theme.spacing(3),
            minWidth: 500,
        },
        uploadButton: {
            marginBottom: theme.spacing(2),
        },
        imageDialog: {
            maxWidth: '90vw',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        imagePreview: {
            maxWidth: '100%',
            maxHeight: '70vh',
            marginBottom: theme.spacing(2),
        },
        editDialogContent: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4),
        },
        formRow: {
            display: 'flex',
            gap: theme.spacing(2),
            alignItems: 'center',
            marginBottom: theme.spacing(3),
        },
        fileInput: {
            display: 'none',
        },
        viewButton: {
            textTransform: 'none',
            padding: '6px 12px',
            marginRight: theme.spacing(2),
        },
        editButton: {
            textTransform: 'none',
            padding: '6px 12px',
        },
        noteField: {
            marginTop: theme.spacing(2),
        },
        fileName: {
            marginLeft: theme.spacing(2),
            fontWeight: 500,
        },
        uploadStatus: {
            marginLeft: theme.spacing(2),
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
        },
        errorText: {
            color: theme.palette.error.main,
            marginTop: theme.spacing(1),
        },
        sourceTypeContainer: {
            marginBottom: theme.spacing(2),
        }
    }));
    const classes = useStyles();

    // const handleFieldBlur = (fieldName) => {
    //     setTouchedFields(prev => ({
    //         ...prev,
    //         [fieldName]: true
    //     }));

    //     if (!educationalReferenceDetails[fieldName]) {
    //         setErrorInputMessage(prev => ({
    //             ...prev,
    //             [fieldName]: `${fieldName.replace('_', ' ')} is required`
    //         }));
    //     }
    // };

    const isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!educationalReferenceDetails.language) {
            errors.language = "Language is required";
            isValid = false;
        }

        if (!educationalReferenceDetails.attachment_type) {
            errors.attachment_type = 'Attachment Type is required';
            isValid = false;
        }

        if (!educationalReferenceDetails.title) {
            errors.title = "Title is required";
            isValid = false;
        }

        // Validate URL based on source type
        if (sourceType === 'upload' && !fileToUpload) {
            errors.url = "Please upload a file";
            isValid = false;
        } else if (sourceType === 'url') {
            if (!educationalReferenceDetails.url) {
                errors.url = "URL is required";
                isValid = false;
            } else if (!isValidUrl(educationalReferenceDetails.url)) {
                errors.url = "Please enter a valid URL";
                isValid = false;
            }
        }

        setErrorInputMessage(errors);
        return isValid;
    };


    const onClick = () => {
        setOpenModal(true)
    }

    const handleClose = (reload) => {
        setOpenModal(false);
        setConfirmation(false);
        setErrorMessage(null);
        setErrorInputMessage(null);
        setSourceType('upload');
        setFileToUpload(null);
        setEducationalReferenceDetails({
            language: '',
            attachment_type: '',
            citation: '',
            url: '',
            title: '',
            description: ''
        });

        if (reload) {
            window.location.reload();
        }
    };

    const onSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        try {
            setLoading(true);
            
        // Determine the URL based on source type
            const finalUrl = sourceType === 'upload' 
                ? fileToUpload.url 
                : educationalReferenceDetails.url;

            const { result } = await createEducationalReference({
                program_id: programId,
                payload: {
                        feeds: [
                            {
                                user_id: patient_id,
                                language: educationalReferenceDetails.language,
                                attachment_type: educationalReferenceDetails.attachment_type,
                                url: finalUrl,
                                citation: educationalReferenceDetails.citation,
                                title: educationalReferenceDetails.title,
                                description: educationalReferenceDetails.description
                            }
                        ]
                    }
                });
            if (result) {
                setOpenModal(false);
                setConfirmation(true);
            }
        } catch (err) {
            if (err && err.inputs) {
                console.log(err.input)
                setErrorInputMessage(err.inputs);
            } else if (err && err.message) {
                console.log(err.message)
                setErrorMessage(err.message);
            }
        } finally {
            setLoading(false);
        }
    }

    const onFieldInput = (e) => {
        const { name, value } = e.target;
        setEducationalReferenceDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (value && errorInputMessage?.[name]) {
            setErrorInputMessage(prev => ({
                ...prev,
                [name]: undefined
            }));
        }
    };



    const languageList = [
        { id: 'en', name: 'English' },
        { id: 'zh', name: 'Chinese' },
        { id: 'bm', name: 'Bahasa' }
    ];

    const handleSourceTypeChange = (e) => {
        const newSourceType = e.target.value;
        setSourceType(newSourceType);
        
        if (newSourceType === 'upload') {
            setEducationalReferenceDetails(prev => ({ ...prev, url: '' }));
        } else {
            setFileToUpload(null);
        }
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploadError(null);
        setIsUploading(true);

        // if (file.size > 5 * 1024 * 1024) {
        //     setUploadError('File too large (max 5MB)');
        //     setIsUploading(false);
        //     return;
        // }

        try {
            const { result } = await upload(file, programId);

            if (!result?.url) {
                throw new Error('Upload failed - no URL returned');
            }
            setFileToUpload({ file, url: result.url });
        } catch (error) {
            console.error('Upload failed:', error);
            setUploadError(error.message || 'File upload failed');
        } finally {
            setIsUploading(false);
        }
    };



    const formContent = (
        <>
            <Grid item xs={12}>
                <InputLabel>Language *</InputLabel>
                <Select
                    required
                    label="Language"
                    name="language"
                    value={educationalReferenceDetails.language}
                    variant="outlined"
                    className={classes.field}
                    onChange={onFieldInput}
                    fullWidth
                >
                    {languageList.map(language => (
                        <MenuItem key={language.id} value={language.id}>
                            {language.name}
                        </MenuItem>
                    ))}
                </Select>
                <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                >
                    {errorInputMessage ? errorInputMessage.language : ''}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <InputLabel>Attachment Type *</InputLabel>
                <FormControl>
                    <RadioGroup
                        row
                        value={educationalReferenceDetails.attachment_type}
                        onChange={onFieldInput}
                        name="attachment_type"
                    >
                        <FormControlLabel value="image" control={<Radio />} label="Image" />
                        <FormControlLabel value="video" control={<Radio />} label="Video" />
                        <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
                    </RadioGroup>
                </FormControl>
                <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                >
                    {errorInputMessage ? errorInputMessage.attachment_type : ''}
                </Typography>
            </Grid>

            <Grid item xs={12} className={classes.sourceTypeContainer}>
                <InputLabel>Source *</InputLabel>
                <FormControl>
                    <RadioGroup
                        row
                        value={sourceType}
                        onChange={handleSourceTypeChange}
                        name="sourceType"
                    >
                        <FormControlLabel 
                            value="upload" 
                            control={<Radio />} 
                            label="Upload File" 
                        />
                        <FormControlLabel 
                            value="url" 
                            control={<Radio />} 
                            label="URL" 
                        />
                    </RadioGroup>
                </FormControl>
            </Grid>

            {sourceType === 'upload' ? (
                <Grid item xs={12}>
                    <div className={classes.formRow}>
                        <input
                            accept="*"
                            className={classes.fileInput}
                            id="file-upload"
                            type="file"
                            onChange={handleFileChange}
                            disabled={isUploading}
                        />
                        <label htmlFor="file-upload">
                            <Button
                                variant="contained"
                                component="span"
                                color="primary"
                                disabled={isUploading}
                                startIcon={isUploading ? <CircularProgress size={20} /> : null}
                            >
                                {isUploading ? 'Uploading...' : 
                                (fileToUpload?.file.name ? 'Change File' : 'Upload File')}
                            </Button>
                        </label>
                        <div className={classes.uploadStatus}>
                            <Typography className={classes.fileName}>
                                {fileToUpload?.file.name || 'No file selected'}
                            </Typography>
                        </div>
                        {uploadError && (
                            <Typography className={classes.errorText}>
                                {uploadError}
                            </Typography>
                        )}
                    </div>
                    {errorInputMessage?.url && (
                        <Typography variant='caption' display='block' gutterBottom color='error'>
                            {errorInputMessage.url}
                        </Typography>
                    )}
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <TextField
                        className={classes.field}
                        label="URL *"
                        name='url'
                        variant="outlined"
                        value={educationalReferenceDetails.url}
                        onChange={onFieldInput}
                        fullWidth
                        placeholder="https://example.com/source"
                    />
                    <Typography
                        variant='caption'
                        display='block'
                        gutterBottom
                        color='error'
                    >
                        {errorInputMessage?.url || ''}
                    </Typography>
                </Grid>
            )}

            <Grid item xs={12}>
                <TextField
                    className={classes.field}
                    label="Title *"
                    name='title'
                    variant="outlined"
                    value={educationalReferenceDetails.title}
                    onChange={onFieldInput} />
                <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                >
                    {errorInputMessage ? errorInputMessage.title : ''}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    className={classes.field}
                    label="Citation"
                    name='citation'
                    variant="outlined"
                    value={educationalReferenceDetails.citation}
                    onChange={onFieldInput} />
                <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                >
                    {/* {errorInputMessage ? errorInputMessage.citation : ''} */}
                </Typography>
            </Grid>
            {/*Description  */}
            <Grid item xs={12}>
                <TextField
                    label="Description"
                    name="description"
                    value={educationalReferenceDetails.description}
                    variant='outlined'
                    className={classes.field}
                    onChange={onFieldInput}
                    multiline
                    rows={4}
                    fullWidth
                />
            </Grid>
        </>
    );
    const formButtons = (
        <>
            <Button onClick={() => handleClose(false)} variant='contained'>
                Close
            </Button>
            <Button
                onClick={onSubmit}
                variant='contained'
                color='secondary'
                disabled={isLoading}
            >
                {isLoading ? 'Submitting...' : 'Submit'}
            </Button>
        </>
    );

    if (isLoading) {
        return <LoadingOverlay />;
    }

    return (
        <>
            <Dialog
                className={classes.customWidth}
                open={openModal}
                title='Add New Educational Reference'
                content={formContent}
                children={formButtons}
                onSubmit={onSubmit}
                onClose={() => handleClose(false)}
            />
            <Dialog
                key='confirmation'
                open={openConfirmation}
                title='Confirmation'
                content='Educational Reference successfully created!'
                children={(
                    <Button onClick={() => handleClose(true)} variant='contained'>
                        Close
                    </Button>
                )}
                onSubmit={onSubmit}
                onClose={() => handleClose(true)}
            />
            <Button
                variant="contained"
                color="primary"
                onClick={onClick}
                style={{ marginRight: 8, marginBottom: 10 }}
            >
                + Add Educational Reference
            </Button>
        </>
    )
}

export default AddEducationalReference;